export const IndustryNames = {
  FOOD: '飲食',
  MANUFACTURE: '食品製造',
  HOTEL: 'ホテル',
  LOGISTICS: '物流',
  MACHINE: '機械・自動車製造',
  OTHER: 'その他',
  NDF: 'NDF',
  HOSHINO: '星野リゾート',
  ITOHAM_YONEKYU: '伊藤ハム米久',
} as const
